export default "__VITE_ASSET__DcA8677K__"